import {
  RecaptchaActionType,
  getOscConfig,
} from "@twiliointernal/e2-commons-shared-definitions";

const { recaptchaSiteKey } = getOscConfig();

/**
 * Get a recaptcha token to send to the backend for verifying a user request.
 *
 * @param {string} action Arbitrary value related to this recaptcha token. Must match the
 * expected Action on the backend.
 *
 * @returns {Promise<string>}
 */
export const getRecaptchaToken = (
  action: RecaptchaActionType
): Promise<string> => {
  // Using any because 'grecaptcha' is provided by the recaptcha
  // script included on index.html. Types not provided by reCaptcha
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { grecaptcha } = window as any;

  if (!grecaptcha) {
    throw new Error("Google reCaptcha script is not loaded");
  }

  return new Promise((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptchaSiteKey, { action }).then((token: string) => {
        resolve(token);
      });
    });
  });
};
